export default class Steel {
  rebarSize = 8
  rebarSpacing = 8
  dirty = false

  deserialize(json) {
    Object.assign(this, json)
    this.dirty = false
  }

  serialize() {
    const d = {}
    Object.keys(this).forEach( (key) => d[key] = this[key] )
    return d
  }

  onUpdate(detail) {
    this.rebarSize =  detail.rebarSize
    this.rebarSpacing = detail.rebarSpacing

    document.dispatchEvent(new CustomEvent('steel-changed'))
  }
}